import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  HStack,
  IconButton,
  Image,
  Input,
  Show,
  Spacer,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { SecondaryMenuItem } from "../../../utils/types";
import { ROUTES } from "../../../utils/constants";
import { Link as ChakraLink } from "@chakra-ui/layout";
import { Link as ReactRouterLink, useLocation } from "react-router-dom";
import { SecondaryMenuItems } from "../../../utils/helper";
import React, { createRef } from "react";
import { HamburgerIcon } from "@chakra-ui/icons";
import Header from "../Header";
import logo from "../../../assets/logo_no_name.png";
import { SocialButtons } from "../index";
import Signature from "../Signature";
export default function SecondaryMenu() {
  const location = useLocation();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const myRef = createRef<HTMLButtonElement>();

  return (
    <Box bg="talesPrimary.500">
      <Flex
        p="10px"
        alignItems="center"
        className="navbar-secondary"
        maxW="7xl"
        m="auto"
      >
        <IconButton
          icon={<HamburgerIcon />}
          aria-label="Menu"
          ref={myRef}
          colorScheme="talesYellow"
          onClick={onOpen}
          display={{ sm: "block", md: "none" }}
        >
          Menu
        </IconButton>
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          finalFocusRef={myRef}
        >
          <DrawerOverlay />
          <DrawerContent backgroundColor="talesPrimary.500">
            <DrawerCloseButton top={"20px"} color={"talesYellow.500"} />
            <DrawerHeader backgroundColor="talesSecondary.500" pt={"50px"}>
              <Flex alignItems="center ">
                <Image src={logo} w="60px" mr={"10px"} />
                <Heading size={"base"} color="talesWhite">
                  Tales Montagnana{" "}
                </Heading>
              </Flex>
            </DrawerHeader>

            <DrawerBody>
              <VStack alignItems="left">
                <ReactRouterLink to={ROUTES.PROGRAMMA}>
                  <Button my={"20px"} onClick={onClose}>
                    Programma
                  </Button>
                </ReactRouterLink>
                {SecondaryMenuItems.map((item: SecondaryMenuItem) =>
                  item.isExternal ? (
                    <a
                      href={item.pathTo}
                      target="_blank"
                      rel="noreferrer"
                      color="talesLightYellow.500"
                      key={item.name}
                      onClick={onClose}
                    >
                      {item.name}
                    </a>
                  ) : (
                    <ChakraLink
                      as={ReactRouterLink}
                      to={item.pathTo}
                      key={item.name}
                      fontSize={"1.2em"}
                      onClick={onClose}
                      variant={
                        item.pathTo === location.pathname
                          ? "navbarCurrent"
                          : "navbar"
                      }
                    >
                      {item.name}
                    </ChakraLink>
                  ),
                )}
              </VStack>
            </DrawerBody>

            <DrawerFooter backgroundColor="talesYellow.500">
              <VStack alignItems="end">
                <Text variant="footer">talesmontagnana@gmail.com</Text>
                <SocialButtons />
                <Text variant="footer" textAlign="right">
                  Tales Montagnana è una manifestazione organizzata da APS Di
                  Regola Arte (CF 91024830282) in collaborazione con Pro Loco
                  Montagnana ed è patrocinata dal Comune di Montagnana.
                </Text>
                <Text color="talesYellow.700">Made with 🍕 by EC</Text>
              </VStack>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
        <HStack spacing="20px" display={{ base: "none", md: "flex" }}>
          {SecondaryMenuItems.map((item: SecondaryMenuItem) =>
            item.isExternal ? (
              <a
                href={item.pathTo}
                target="_blank"
                rel="noreferrer"
                color="talesLightYellow.500"
                key={item.name}
              >
                {item.name}
              </a>
            ) : (
              <ChakraLink
                as={ReactRouterLink}
                to={item.pathTo}
                key={item.name}
                variant={
                  item.pathTo === location.pathname ? "navbarCurrent" : "navbar"
                }
              >
                {item.name}
              </ChakraLink>
            ),
          )}
        </HStack>
        <Spacer />
        <ReactRouterLink to={ROUTES.PROGRAMMA}>
          <Button>Programma</Button>
        </ReactRouterLink>
      </Flex>
    </Box>
  );
}
